import React from "react";

import { cloneArray } from "../lib/cloneArray";

class CheckboxOptionsInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value.length > 0 ? cloneArray(this.props.value) : []
        };
    }

    handleChange(newVal, e) {
        let currentValue = this.state.value;

        if (e.target.checked) {
            currentValue.push(newVal);
        }
        else {
            currentValue = currentValue.filter(v => v !== newVal);
        }

        this.setState(
            {
                value: currentValue
            },
            this.props.onChange.bind(null, currentValue)
        );
    }

    render() {
        return (
            <fieldset>
                <span className={this.props.classes.checkboxList}>
                    {this.props.options.map(opt => (
                        <div key={opt.value} className={this.props.classes.checkboxList}>
                            <input
                                type="checkbox"
                                name={this.props.name}
                                id={opt.value}
                                aria-labelledby={this.props.labelId}
                                checked={this.state.value.indexOf(opt.value) > -1}
                                className={this.props.classes.checkbox}
                                required={this.props.required ? "required" : undefined}
                                onChange={this.handleChange.bind(this, opt.value)}
                                onBlur={this.props.onBlur.bind(null, this.state.value)}
                            />
                            <label
                                className={this.props.classes.checkboxLabel}
                                id={this.props.labelId}
                                htmlFor={opt.value}
                            >
                                {opt.text}
                            </label>
                        </div>
                    ))}
                </span>
            </fieldset>
        );
    }
}

CheckboxOptionsInput.defaultProps = {
    classes: {},
    name: "",
    value: [],
    options: [],
    onChange: () => {},
    onBlur: () => {}
};

export default CheckboxOptionsInput;
